import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { usePermission } from '../hooks/usePermission';
import { Modules } from '../constants/permissions';

interface SidebarProps {
  collapsed: boolean;
  onToggle: () => void;
}

interface MenuItem {
  path: string;
  label: string;
  shortLabel: string;
  module: string;
  activeColor?: string;
}

const menuItems: MenuItem[] = [
  { path: '/manager-dashboard', label: '主管監控',  shortLabel: 'M', module: Modules.MANAGER_DASHBOARD },
{ path: '/sc-tracker',        label: 'SC單追蹤',  shortLabel: 'S', module: Modules.SC_TRACKER },
  { path: '/database-search',   label: '資料庫搜尋', shortLabel: 'Q', module: Modules.DATABASE_SEARCH },
  { path: '/mekak',             label: '知識管理',   shortLabel: 'K', module: Modules.MEKAK },
  { path: '/whiteboard',        label: '白板',       shortLabel: 'W', module: Modules.WHITEBOARD },
  { path: '/esp',               label: 'ESP平台',    shortLabel: 'C', module: Modules.ESP },
  { path: '/user',              label: '使用者管理', shortLabel: 'U', module: Modules.USER },
  { path: '/audit',             label: '資料庫監控', shortLabel: 'D', module: Modules.AUDIT, activeColor: 'bg-red-500' },
  // ERP架構分析已移入資料庫監控頁的 Tab（2026-06-07）
  { path: '/dev-dashboard',     label: '開發進度',   shortLabel: 'B', module: Modules.DEV_DASHBOARD },
  { path: '/system-announcements', label: '系統公告', shortLabel: 'A', module: Modules.SYSTEM_ANNOUNCEMENTS },
];

const Sidebar: React.FC<SidebarProps> = ({ collapsed, onToggle }) => {
  const location = useLocation();
  const { hasAnyModulePermission, isAdmin } = usePermission();

  const isActive = (path: string) => {
    if (path === '/user') return location.pathname.startsWith('/user');
    if (path === '/mekak') return location.pathname.startsWith('/mekak');
    if (path === '/whiteboard') return location.pathname.startsWith('/whiteboard');
    return location.pathname === path || (path === '/manager-dashboard' && location.pathname === '/');
  };

  const visibleItems = menuItems.filter(
    item => isAdmin || hasAnyModulePermission(item.module)
  );

  return (
    <div
      className={`fixed left-0 top-0 h-screen bg-white shadow-lg transition-all duration-300 z-20 ${
        collapsed ? 'w-16' : 'w-64'
      }`}
    >
      <button
        onClick={onToggle}
        className="absolute -right-3 top-20 w-6 h-6 bg-white border border-gray-300 rounded-full shadow flex items-center justify-center text-gray-500 hover:bg-gray-100 z-30"
      >
        {collapsed ? '›' : '‹'}
      </button>

      <div className={collapsed ? 'p-2' : 'p-6'}>
        {!collapsed && (
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Edye</h2>
        )}
        <nav className={`space-y-2 ${collapsed ? 'mt-16' : ''}`}>
          {visibleItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              title={item.label}
              reloadDocument={item.path === '/sc-tracker' && isActive('/sc-tracker')}
              className={`block py-2 rounded-lg transition-colors ${
                isActive(item.path)
                  ? `${item.activeColor || 'bg-blue-500'} text-white`
                  : 'text-gray-700 hover:bg-gray-100'
              } ${collapsed ? 'text-center px-1' : 'px-4'}`}
            >
              {collapsed ? item.shortLabel : item.label}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
